import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,{attrs:{"label":_vm.$t('Min per order'),"outlined":"","type":"number"},model:{value:(_vm.min_per_order),callback:function ($$v) {_vm.min_per_order=_vm._n($$v)},expression:"min_per_order"}})}
var staticRenderFns = []

export { render, staticRenderFns }